import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import {
  ErrorDetails,
  CarrierPreferences
} from '../../interfaces/apiInterfaces';

export class GetCarrierPreferenceCommand extends IRequestCommand<
  IGetCarrierPreferenceResponse,
  ErrorDetails,
  IGetCarrierPreferenceCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierUserId}/preferences';
  public override setParameters(parameters: IGetCarrierPreferenceCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId.toString()
    );
  }
}

export interface IGetCarrierPreferenceCommandParameters
  extends ICommandParameters {
  carrierUserId: string;
}

export interface IGetCarrierPreferenceResponse
  extends ICommandResponse,
    CarrierPreferences {}
